import yup, { enumValidator, integerPositiveValidator } from '~/utils/validators.yup';

import { COMPARED_OPTIONS } from '~/config/constants';
export const dvComparedDetailRule = {
    dvComparedDetail: yup.object().shape({
        dvCompareOption: enumValidator(COMPARED_OPTIONS),
        dvCompareValue: integerPositiveValidator.required().min(0).max(12),
    }),
};
